import history from 'js/history';

export class QuickStartApi {
    static recaptchaHandler = null;

    static setRecaptchaHandler(handler) {
        QuickStartApi.recaptchaHandler = handler;
    }

    constructor(getRecaptchaToken = null) {
        this.getRecaptchaToken = getRecaptchaToken;
        this.path = ['rest', 'quick-start'];

        if (process.env.REACT_APP_CLUSTER === 'dev') {
            this.host = `http://${window.location.hostname}:8000`;
        } else if (process.env.REACT_APP_CLUSTER === 'avocado') {
            this.host = 'https://api.4d.silverbulletcloud.com';
        } else {
            this.host = `https://api-${process.env.REACT_APP_CLUSTER}.4d.silverbulletcloud.com`;
        }
    }

    async help(data = {}, params = {}, options = {}) {
        this.path.push('help');
        return this.#call(params, { ...options, method: 'POST', body: data });
    }

    async load(params = {}, options = {}) {
        this.path.push('load');
        return this.#call(params, { ...options, method: 'GET' });
    }

    async query(data = {}, params = {}, options = {}) {
        this.path.push('query');
        return this.#call(params, { ...options, method: 'POST', body: data });
    }

    async scale(data = {}, params = {}, options = {}) {
        this.path.push('scale');
        return this.#call(params, { ...options, method: 'POST', body: data });
    }

    async submit(data = {}, params = {}, options = {}) {
        this.path.push('submit');
        return this.#call(params, { ...options, method: 'POST', body: data });
    }

    async validate(data = {}, params = {}, options = {}) {
        this.path.push('validate');
        return this.#call(params, { ...options, method: 'POST', body: data });
    }

    async #call(params = {}, options = {}) {
        const headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        };
        const body = { ...options.body };

        if (QuickStartApi.recaptchaHandler && options.method !== 'GET') {
            const action = this.path[this.path.length - 1];
            const token = await QuickStartApi.recaptchaHandler(action);
            body.recaptcha_token = token;
        }

        const callOptions =
            options.method !== 'GET'
                ? { headers, ...options, body: JSON.stringify(body) }
                : { headers, ...options };

        const urlPath = [this.host, ...this.path].join('/');
        const urlParams = new URLSearchParams();

        Object.entries(params).forEach(([name, value]) => {
            if (Array.isArray(value)) {
                value.forEach((param) => urlParams.append(name, param));
            } else {
                urlParams.set(name, value);
            }
        });

        const url = `${urlPath}?${urlParams.toString()}`;

        try {
            const response = await fetch(url, callOptions);
            const { status } = response;

            if (status === 401) {
                history.replace('/quick-start/errors/401/');
            }

            if (status === 429) {
                history.replace('/quick-start/errors/429/');
            }

            if (status < 200 || status >= 300) {
                throw await response.json();
            }

            if (callOptions.method === 'DELETE') {
                return null;
            }

            return response.json();
        } catch (err) {
            console.log(err); // eslint-disable-line no-console
            throw err;
        }
    }
}

export default function quickStartApi() {
    return new QuickStartApi();
}

window.quickStartApi = quickStartApi; // for debugging purposes
